import styled, { css } from "styled-components";

export const PageNumber = styled.div`
  ${({ theme }) => css`
    margin-left: 4px;
    font-size: 12px;
    font-weight: 400;
    cursor: pointer;

    color: #334D6E;
    ${p => p.selected && css`
      color: ${theme?.colour?.primary ?? "#1DBD6B"};
    `}
  `}
`;